module.exports = __webpack_public_path__ + "static/img/COC2023-16.a2eadbb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-16.png
// module id = ih/d
// module chunks = 0